import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { RadioOption } from './RadioOption';
/**
 * @deprecated
 */

export var RadioBlock = /*#__PURE__*/React.forwardRef(function (props, ref) {
  useDeprecatedComponentWarning({
    component: 'RadioBlock',
    migration: 'Use <RadioOption> directly instead.'
  });
  return /*#__PURE__*/React.createElement(RadioOption, _extends({}, props, {
    inline: false,
    ref: ref
  }));
});
RadioBlock.displayName = 'RadioBlock';